import merge from "lodash/merge"
import FileStore from "@/store/entity/file"

class TreatiseReq {
  constructor() {
    this.id = 0
    this.require = ""
    // this.file_metadata = new FileStore(),
    this.file_metadata = null
    this.conference_id = 0
  }
  static getList(conference_id) {
    const url = process.env.VUE_APP_API_URL + "api/v1/conftreatisereq"
    let filters = { conference_id: conference_id }
    return axios.get(url, { params: filters }).then((res) => {
      let c = new TreatiseReq()
      res.data.forEach((x) => {
        Object.assign(c, x)
      })

      return c
    })
  }

  createOrUpdate() {
    const url = process.env.VUE_APP_API_URL + "api/v1/conftreatisereq"
    if (this.id == 0) {
      //新增
      const data = merge({}, this)

      return axios.post(url, data).then((res) => {
        let result = new TreatiseReq()
        result = merge(result, res)
        return result
      })
    } else {
      //修改
      const data = merge({}, this)

      return axios.put(url, data).then((res) => {
        let result = new TreatiseReq()
        result = merge(result, res.data.item)
        return result
      })
    }
  }
  static delete(id) {
    const url = process.env.VUE_APP_API_URL + "api/v1/conftreatisereq/"
    return axios.delete(url, { params: { id: id } }).then((res) => {
      return true
    })
  }
}
export { TreatiseReq }
